import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InlineSVGModule } from 'ng-inline-svg-2';

import { CoreModule } from 'src/app/core/core.module';
import { ShareModule } from 'src/app/shared/share.module';
import { TranslationModule } from '../../i18n/translation.module';
import { AuditDetailComponent } from './audit/audit-detail/audit-detail.component';
import { AuditComponent } from './audit/audit.component';
import { HelpPageComponent } from './help-page/help-page.component';

@NgModule({
  declarations: [AuditComponent, AuditDetailComponent, HelpPageComponent],
  imports: [
    CommonModule,
    ShareModule,
    TranslationModule,
    ReactiveFormsModule,
    FormsModule,
    CoreModule,
    InlineSVGModule,
  ],
  exports: [AuditComponent, AuditDetailComponent, HelpPageComponent],
})
export class PagesSharedModule {}
